import { languages, type LanguageKey } from "@/providers/LocalizationProvider";
import type { ProfileTerm } from "@/types/doctor";

// How many specialties the doctor card highlights; the trappist orders them
// in the dashboard with their main focus first.
export const TOP_SPECIALTIES = 3;

/**
 * Catalogue label in the visitor's language, falling back to English, then
 * any translation, then the slug - admins may fill in only some languages.
 */
export function termLabel(term: ProfileTerm, language: string): string {
  const names = term.names ?? {};
  return names[language] || names.en || Object.values(names).find(Boolean) || term.slug;
}

/**
 * Native name of a session language. Trappists pick from the platform's
 * supported languages, so the rawej language list covers them; anything
 * unknown is shown as its code.
 */
export function sessionLanguageLabel(code: string): string {
  return languages[code as LanguageKey]?.label ?? code;
}
